import React from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { FormField, Input } from '@legalshield/adonis-ux-framework';

type Props<T extends FieldValues> = {
  control: Control<T>;
  name: Path<T>;
  label: string;
  required?: boolean;
  placeholder?: string;
  maxLength?: number;
  type?: 'text' | 'tel' | 'number' | 'password' | 'email' | 'url';
};

const TextField = <T extends FieldValues>({
  control,
  name,
  label,
  required,
  placeholder,
  maxLength,
  type = 'text',
}: Props<T>) => (
  <Controller
    control={control}
    name={name}
    render={({ field, fieldState }) => (
      <FormField
        id={String(name)}
        label={label}
        required={required}
        status={fieldState.error ? 'invalid' : undefined}
        validationHint={fieldState.error?.message}
      >
        <Input
          placeholder={placeholder ?? label}
          type={type}
          value={(field.value as string | undefined) ?? ''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const next =
              maxLength && e.target.value.length > maxLength ? e.target.value.slice(0, maxLength) : e.target.value;
            field.onChange(next);
          }}
          onBlur={field.onBlur}
          status={fieldState.error ? 'invalid' : undefined}
        />
      </FormField>
    )}
  />
);

export default TextField;
